/* eslint-disable @typescript-eslint/no-unused-expressions */
import React, { useCallback, useEffect, useState } from "react";
import type { ComponentProps } from "react";
import { PasswordField, Stack } from "@telefonica/mistica";
import { strings } from "../../../localization";
import { onlyNumber } from "../../../utils/formatters";

export interface ValidatedProps {
	isValid: boolean;
	value: string;
}

interface inputsNewPasswordProps {
	propsStack?: ComponentProps<typeof Stack>;
	propsPasswordField?: ComponentProps<typeof PasswordField>;
	propsRepeatPasswordField?: ComponentProps<typeof PasswordField>;
	isValidated({ isValid, value }: ValidatedProps): void;
	handleErrorFormEvent?(errorText: string): void;
}

const { confirmLabel, errorOfLength, errorOfMatch, label } = strings.organisms.inputsNewPassword;

export const InputsNewPassword: React.FC<inputsNewPasswordProps> = ({
	propsStack = {
		space: 16,
	},
	propsPasswordField = {
		label,
		name: "new-password",
	},
	propsRepeatPasswordField = {
		label: confirmLabel,
		name: "confirm-new-password",
	},
	isValidated,
	handleErrorFormEvent,
}) => {
	const [firstPassword, setFirstPassword] = useState("");
	const [errorInput, setErrorInput] = useState("");
	const [repeatPassword, setRepeatPassword] = useState("");
	const [errorRepeatInput, setErrorRepeatInput] = useState("");

	// Faz as validações se as senhas são iguais e se possuem 6 dígitos.
	useEffect(() => {
		if (firstPassword.length === 6 && repeatPassword.length === 6) {
			if (firstPassword === repeatPassword) {
				isValidated({ isValid: true, value: firstPassword });
				setErrorRepeatInput("");
			} else {
				isValidated({ isValid: false, value: firstPassword });
				if (handleErrorFormEvent) {
					handleErrorFormEvent(errorOfMatch);
				}
				setErrorRepeatInput(errorOfMatch);
			}
		} else {
			isValidated({ isValid: false, value: firstPassword });
		}
	}, [firstPassword, repeatPassword]);

	// Altera o valor do firstPassword removendo qualquer carácter que não seja número fazendo validação do seu tamanho.
	const onChangeFirsPassword = useCallback(
		(value: string): void => {
			const inputValue = onlyNumber(value);

			if (inputValue.length > 0 && inputValue.length < 6) {
				setErrorInput(errorOfLength as string);
			} else {
				setErrorInput("");
			}

			setFirstPassword(inputValue);
		},
		[firstPassword],
	);

	// Altera o valor do repeatPassword removendo qualquer carácter que não seja número fazendo validação do seu tamanho.
	const onChangeRepeatPassword = useCallback(
		(value: string): void => {
			const inputValue = onlyNumber(value);

			if (inputValue.length > 0 && inputValue.length < 6) {
				setErrorRepeatInput(errorOfLength as string);
			} else {
				setErrorRepeatInput("");
			}

			setRepeatPassword(inputValue);
		},
		[firstPassword],
	);

	return (
		<Stack {...propsStack}>
			<PasswordField
				maxLength={6}
				fullWidth
				helperText={errorInput}
				error={!!errorInput}
				value={firstPassword}
				onChangeValue={(value) => onChangeFirsPassword(value)}
				data-cs-mask
				{...propsPasswordField}
			/>
			<PasswordField
				maxLength={6}
				fullWidth
				helperText={errorRepeatInput}
				error={!!errorRepeatInput}
				value={repeatPassword}
				onChangeValue={(value) => onChangeRepeatPassword(value)}
				data-cs-mask
				{...propsRepeatPasswordField}
			/>
		</Stack>
	);
};
